import { render, staticRenderFns } from "./RecoveryAtIdError.html?vue&type=template&id=82655494&scoped=true&"
import script from "./RecoveryAtIdError.vue?vue&type=script&lang=js&"
export * from "./RecoveryAtIdError.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAtIdError.scss?vue&type=style&index=0&id=82655494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82655494",
  null
  
)

export default component.exports